export const GROUPS_SELECTOR_DRAG_TYPE = "GROUP";
